<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      size="mini"
      resizable
      :scroll-y="{ enabled: false }"
      cell-class-name="align-top"
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('form_title_item') || '出差费用报销单明细' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditFormDialog({
                  type: 'add',
                })
              "
              v-if="allow('A')"
              v-show="tripReimbursementCode && !disabled"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:isSchedule="{ row }">
        <el-tag
          size="mini"
          :type="
            row.isSchedule === 'N'
              ? 'primary'
              : row.isSchedule === 'Y'
              ? 'success'
              : row.isSchedule === 'C'
              ? 'danger'
              : 'warning'
          "
        >
          {{ row.v_isSchedule }}
        </el-tag>
      </template>
      <template v-slot:showScheduleInfo="{ row }">
        <span
          >{{ row.departureCityName }} {{ '-->' }}
          {{ row.destinationCityName }}</span
        >
        <br />
        <span>{{ row.scheduleStartDate }} 至 {{ row.scheduleEndDate }}</span>
        <br />
        <span>{{ row.v_tripType }}</span>
      </template>
      <template v-slot:showCustInfo="{ row }">
        <span>{{ $l('table_label_scm') || '供应商' }}：{{ row.scmName }}</span>
        <br />
        <span
          >{{ $l('INDEX.label_customer') || '客户' }}：{{ row.custName }}</span
        >
        <br />
        <span
          >{{ $l('INDEX.table_label_cust_order_no_list') || '订单' }}：{{
            row.custOrderNoList
          }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="allow('M')"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditFormDialog({
                  type: 'edit',
                  code: row.tripReimbursementItemCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('dialog_title_reportInfo_detail') || '查看出差报告'"
            placement="top"
          >
            <i
              class="el-icon-tickets tool-btn"
              @click="
                openReportTableDialog({
                  code: row.tripReimbursementItemCode,
                  type: 'detail',
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('dialog_title_reportInfo_edit') || '编辑出差报告'"
            placement="top"
            v-show="allow('M')"
            v-if="row.isSchedule !== 'C' && !disabled"
          >
            <i
              class="el-icon-edit-outline tool-btn"
              @click="
                openReportTableDialog({
                  code: row.tripReimbursementItemCode,
                  type: 'edit',
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="1000px"
      top="10vh"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :type="editFormDialogOptions.type"
        :tripReimbursementCode="tripReimbursementCode"
        :tripReimbursementItemCode="editFormDialogOptions.code"
        :salesPersonCode="salesPersonCode"
        @reload="getData"
        @close="closeEditFormDialog"
        @getItemData="getItemData"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>

    <ReportForm
      :visible.sync="reportTableOptions.visible"
      :title="$l('dialog_title_reportInfo') || '出差报告'"
      :tripReimbursementCode="tripReimbursementCode"
      :tripReimbursementItemCode="reportTableOptions.code"
      :disabled="reportTableOptions.disabled"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditForm from '../item-edit'
import ReportForm from '../report-edit'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading, TableAutoHeight],
  components: { EditForm, ReportForm },
  props: {
    disabled: { type: Boolean, default: false },
    tripReimbursementCode: { type: String, default: '' },
    salesPersonCode: { type: String, default: '' },
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
      },
      tableColumns: tableColumns(this),
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
      reportTableOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    footerData() {
      if (!this.data || !this.data.length) return [[]]
      const {
        ticketFee = 0,
        trafficFee = 0,
        hotelFee = 0,
        travellingAllowance = 0,
        otherFee = 0,
        subAmount = 0,
        billCount = 0,
      } = this.data.reduce(
        (result, next) => {
          result.ticketFee = add(result.ticketFee, next.ticketFee)
          result.trafficFee = add(result.trafficFee, next.trafficFee)
          result.hotelFee = add(result.hotelFee, next.hotelFee)
          result.travellingAllowance = add(
            result.travellingAllowance,
            next.travellingAllowance
          )
          result.otherFee = add(result.otherFee, next.otherFee)
          result.subAmount = add(result.subAmount, next.subAmount)
          result.billCount = add(result.billCount, next.billCount)
          return result
        },
        {
          ticketFee: 0,
          trafficFee: 0,
          hotelFee: 0,
          travellingAllowance: 0,
          otherFee: 0,
          subAmount: 0,
        }
      )
      const result = [
        this.$l('INDEX.total') || '合计',
        '',
        '',
        '',
        '',
        '',
        '',
        ticketFee.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        trafficFee.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        hotelFee.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        travellingAllowance.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        otherFee.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        subAmount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        billCount,
      ]

      return [result]
    },
  },
  methods: {
    getData() {
      if (!this.tripReimbursementCode) return
      this.loading = true
      this.$api
        .userTripReimbursementItemListApi({
          tripReimbursementCode: this.tripReimbursementCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        add: this.$l('dialog_title_item_add') || '新增出差费用报销单明细',
        edit: this.$l('dialog_title_item_edit') || '编辑出差费用报销单明细',
        detail: this.$l('dialog_title_item_detail') || '出差费用报销单明细详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
        type: type,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    openReportTableDialog({ code = '', type = '' }) {
      this.reportTableOptions = {
        visible: true,
        code: code,
        disabled: type === 'detail',
      }
    },
    getItemData() {
      this.$emit('getItemData')
    },
    footerMethod() {
      return this.footerData
    },
  },
}
</script>
